import {
  styled,
  Text,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, {useEffect, useState} from 'react';
import {Surface, Symbols} from 'recharts';
import {Payload} from 'recharts/types/component/DefaultLegendContent';

interface CustomLegendProps {
  payload?: Payload[];
}

const CustomLegendContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 800px;
`;

const CustomLegendList = styled.ul`
  li {
    list-style: none;
  }
`;

const SurfaceContainer = styled.div`
  display: flex;
  align-items: baseline;

  div {
    margin-left: 4px;
  }
`;

const VwLegend = styled.div<{isVw?: boolean}>`
  color: ${(props) => (props.isVw ? '#00437A' : '#000')};
`;

const CustomLegend: React.FC<CustomLegendProps> = (props) => {
  const {payload} = props;

  const [legends, setLegends] = useState<Payload[]>([]);

  const compare = (a: Payload, b: Payload) => {
    const aObj = JSON.parse(a.value);
    const bObj = JSON.parse(b.value);
    const placement = aObj.total < bObj.total ? 1 : -1;
    return aObj.make == 'Volkswagen' ? -1 : placement;
  };

  useEffect(() => {
    if (!payload) return;

    const payloadSorted = payload.slice().sort(compare);

    setLegends(payloadSorted);
  }, [payload]);

  return legends ? (
    <CustomLegendContainer aria-hidden="true">
      <CustomLegendList aria-hidden="true">
        {legends?.map((entry) => {
          const {color} = entry;
          const value = JSON.parse(entry.value);
          return (
            <li key={JSON.parse(entry.value).make}>
              <SurfaceContainer>
                <Surface width={10} height={10}>
                  <Symbols cx={5} cy={5} type="circle" size={80} fill={color} />
                </Surface>

                <VwLegend isVw={value.make == 'Volkswagen'}>
                  <Text
                    bold={value.make == 'Volkswagen'}
                    color={TokenTextColor.inherit}
                    appearance={TokenTextAppearance.copy100}
                  >
                    {value.year +
                      ' ' +
                      value.make +
                      ' ' +
                      value.model +
                      ' ' +
                      value.series}
                  </Text>
                </VwLegend>
              </SurfaceContainer>
            </li>
          );
        })}
      </CustomLegendList>
    </CustomLegendContainer>
  ) : null;
};

export default CustomLegend;
